import { Heading, Inline, Stack, Text, textVariants } from '@etg/wings';
import { useDirection, useTranslation } from '@eti/providers';
import { AirplaneLanding, AirplaneTakeoff } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { constants } from '@eti/utils';
import type { TravelerBaggageInfo } from './models';
import BoundBaggageInfoPerTraveler from './BoundBaggageInfoPerTraveler';

const disclaimerStyles = css`
  color: #737373;
`;

interface BaggageInfoOfBoundProps {
  baggageInfoPerTraveler: TravelerBaggageInfo[];
  boundId: string;
  isReturnBound: boolean;
  destination: string;
  origin: string;
}

const BoundBaggageInfo = ({
  baggageInfoPerTraveler,
  boundId,
  destination,
  isReturnBound,
  origin,
}: BaggageInfoOfBoundProps) => {
  const { isRTL } = useDirection();
  const { t } = useTranslation();

  return (
    <Stack>
      <Heading level={3}>
        <Inline spacing={8}>
          {isReturnBound ? (
            <AirplaneLanding
              data-testid={`bound-baggage-${boundId}-landing-icon`}
              mirrored={isRTL}
              size={20}
            />
          ) : (
            <AirplaneTakeoff
              data-testid={`bound-baggage-${boundId}-takeoff-icon`}
              mirrored={isRTL}
              size={20}
            />
          )}
          <span data-testid={`bound-baggage-${boundId}-origin`}>{origin}</span>
          <span>-</span>
          <span data-testid={`bound-baggage-${boundId}-destination`}>{destination}</span>
        </Inline>
      </Heading>
      <Stack role="list">
        {baggageInfoPerTraveler.map((travelerBaggageInfo, travelerIndex) => (
          <Stack align="start" key={travelerBaggageInfo.id} role="listitem" spacing={4}>
            <Text
              className={constants.MOUSE_FLOW_CLASS_NAMES}
              data-testid={`bound-baggage-${boundId}-traveler-${travelerIndex}-name`}
              variant={textVariants._14_BOLD}
            >
              {travelerBaggageInfo.name}
            </Text>
            <BoundBaggageInfoPerTraveler
              dataTestId={`bound-baggage-${boundId}-traveler-${travelerIndex}`}
              travelerBaggageInfo={travelerBaggageInfo}
            />
          </Stack>
        ))}
      </Stack>
      <Text className={disclaimerStyles} variant={textVariants._14}>
        {t('OrderDetails.CarrierUpdates.Disclaimer')}
      </Text>
    </Stack>
  );
};

export default BoundBaggageInfo;
